import LogoGuerra from "../../assets/logo2.png"
import LogoBB from "../../assets/logo-bb.svg"
import styles from "./styles.module.css"

function Header({onLogoClick}){
    return(
        <header className={styles.headerContainer}>
            <div className={styles.logosContainer} onClick={onLogoClick}>
                <img src={LogoGuerra}/>
                <img src={LogoBB} />
            </div>
        </header>
    )
}

export default Header